export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly body: unknown,
    message: string,
  ) {
    super(message);
  }
}

export interface ApiOptions extends RequestInit {
  query?: Record<string, string | number | undefined>;
}

const BASE = '/api';

export async function api<T = unknown>(path: string, opts: ApiOptions = {}): Promise<T> {
  const { query, headers, body, ...rest } = opts;
  let url = `${BASE}${path}`;
  if (query) {
    const search = new URLSearchParams();
    for (const [k, v] of Object.entries(query)) {
      if (v !== undefined) search.set(k, String(v));
    }
    const qs = search.toString();
    if (qs) url += `?${qs}`;
  }

  const init: RequestInit = {
    ...rest,
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      ...(headers as Record<string, string>),
    },
    body: body !== undefined && typeof body !== 'string' ? JSON.stringify(body) : body,
  };

  const res = await fetch(url, init);

  if (res.status === 204) return undefined as T;

  const isJson = res.headers.get('content-type')?.includes('application/json');
  const data = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const message =
      (typeof data === 'object' && data && 'message' in data && typeof data.message === 'string'
        ? data.message
        : null) ?? `Request failed: ${res.status}`;
    throw new ApiError(res.status, data, message);
  }
  return data as T;
}
